import { groq } from 'next-sanity'
import { ButtonQuery } from '../atoms/ButtonQuery'

export const LinkBoxGalleryQuery = groq`
_type == "LinkBoxGallery" => {
  ...,
  heading,
  links[] {
    ...,
    ${ButtonQuery}
  },
  image {
    asset-> {
      ...,
      ...,
      _id,
      url,
      _type,
      altText,
      description,
      title,
      metadata {
        blurHash,
        dimensions
      }
    }
  }
}
`
